import React, { Fragment } from 'react';

import ConfirmModal from '../../../utilities/form-components/ConfirmModal';

const PublishModal = ({
  end,
  isBin,
  isTimed,
  publishFunction,
  showPublish,
  start,
  text,
  titleText,
  togglePublishModal,
  toggleSponLotModal,
}) => {
  let bodyText = '';
  bodyText = (
    <Fragment>
      Are you sure you want to publish {text}? All items that are published will be visible on
      site and available for {isBin ? 'purchase' : 'bidding'}.

      {isTimed === 1 && (
        <Fragment>
          <p className="mb-0 mt-2"><span className="font-weight-bold">First lot ends:</span>&nbsp;{start}</p>
          <p><span className="font-weight-bold">Last lot ends:</span>&nbsp;{end}*</p>
          <p>*bidding may extend end time</p>
        </Fragment>
      )}
    </Fragment>
  );

  const actionFunction = () => {
    publishFunction();
    toggleSponLotModal();
  };

  return (
    <ConfirmModal
      actionFunction={actionFunction}
      bodyText={bodyText}
      buttonText="Publish"
      showModal={showPublish}
      title={titleText}
      toggleFunction={togglePublishModal}
    />
  );
};

export default PublishModal;
